var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "flex mb-3 items-start" }, [
        _c(
          "div",
          { staticClass: "flex flex-wrap w-9/12 mr-20" },
          [
            _c(
              "FormGroup",
              { staticClass: "mr-6 w-60", attrs: { title: "Scheduler View" } },
              [
                _c("SchedulerViewSelect", {
                  attrs: { isAdmin: _vm.isAdmin },
                  model: {
                    value: _vm.schedulerView,
                    callback: function ($$v) {
                      _vm.schedulerView = $$v
                    },
                    expression: "schedulerView",
                  },
                }),
              ],
              1
            ),
            _vm.showProjects
              ? _c(
                  "FormGroup",
                  { staticClass: "w-60 mr-6 flex items-center pt-6" },
                  [
                    _c("Checkbox", {
                      attrs: {
                        id: _vm.showActivitiesCheckbox.id,
                        name: _vm.showActivitiesCheckbox.name,
                      },
                      model: {
                        value: _vm.showActivitiesCheckbox.selected,
                        callback: function ($$v) {
                          _vm.$set(_vm.showActivitiesCheckbox, "selected", $$v)
                        },
                        expression: "showActivitiesCheckbox.selected",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showManagersSelect
              ? _c(
                  "FormGroup",
                  {
                    staticClass: "w-60 dropdownMaxWidth",
                    attrs: { title: "Manager's Name" },
                  },
                  [
                    _c("ManagersMultiselect", {
                      attrs: { withoutLoading: "" },
                      model: {
                        value: _vm.selectedManagersIds,
                        callback: function ($$v) {
                          _vm.selectedManagersIds = $$v
                        },
                        expression: "selectedManagersIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showContractors
              ? _c(
                  "FormGroup",
                  {
                    staticClass: "min-w-60 dropdownMaxWidth",
                    attrs: { title: "Contractor Name" },
                  },
                  [
                    _c("ContractorsMultiselect", {
                      attrs: {
                        contractorsConditions:
                          _vm.contractorsMultiselectConditions,
                      },
                      model: {
                        value: _vm.selectedContractorsIds,
                        callback: function ($$v) {
                          _vm.selectedContractorsIds = $$v
                        },
                        expression: "selectedContractorsIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "flex justify-end items-center min-w-52 w-3/12 ml-auto mt-5",
          },
          [
            _vm.showProjects
              ? _c("ProjectModalWithButton", {
                  staticClass: "mr-8",
                  attrs: {
                    companyId: _vm.company.id,
                    currentUser: _vm.currentUser,
                  },
                })
              : _vm._e(),
            _vm.showFilterIcon
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center rounded-full mr-2 px-5 py-2 relative max-w-full bg-emphasizegray",
                  },
                  [
                    _c("FilterIcon", {
                      staticClass: "h-4 w-4 cursor-pointer",
                      nativeOn: {
                        click: function ($event) {
                          return _vm.toggleAdditionalFilters.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    }),
                    _c("br"),
                    _c("a", { attrs: { href: "#" } }, [
                      _c(
                        "p",
                        {
                          staticClass: "pl-2",
                          on: { click: _vm.toggleAdditionalFilters },
                        },
                        [_vm._v("Filter")]
                      ),
                    ]),
                    _vm.showAppliedFiltersBubble
                      ? _c("TabNotificationBubble", {
                          staticClass: "-ml-2 flex-shrink-0 mb-4",
                          attrs: {
                            notification: _vm.appliedFiltersNumber,
                            infoGreen: "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm.showManagers
        ? _c("ManagerScheduler", {
            staticClass: "mb-10",
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              currentUser: _vm.currentUser,
              selectedManagersIds: _vm.selectedManagersIds,
              company: _vm.company,
              companyId: _vm.company.id,
              shouldClearFilters: _vm.shouldClearFilters,
              showAdditionalFilters: _vm.showAdditionalFilters,
            },
            on: {
              rangechanged: _vm.rangeChanged,
              appliedFiltersChanged: _vm.handleAppliedFiltersChanged,
              filtersReset: _vm.handleManagerFiltersReset,
              close: _vm.toggleAdditionalFilters,
            },
          })
        : _vm._e(),
      _vm.showProjects
        ? _c("ProjectScheduler", {
            staticClass: "mb-10",
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              currentUser: _vm.currentUser,
              shouldClearFilters: _vm.shouldClearFilters,
              showAdditionalFilters: _vm.showAdditionalFilters,
              selectedProjectsIds: _vm.selectedProjectsIds,
              companyId: _vm.company.id,
              showActivities: _vm._showActivities,
            },
            on: {
              rangechanged: _vm.rangeChanged,
              appliedFiltersChanged: _vm.handleAppliedFiltersChanged,
              selectedProjectIdsUpdated: _vm.handleChosenProjectsUpdated,
              filtersReset: _vm.handleProjectFiltersReset,
              close: _vm.toggleAdditionalFilters,
            },
          })
        : _vm._e(),
      _vm.showContractors
        ? _c("ContractorScheduler", {
            attrs: {
              axisStart: _vm.dateRange.startDate,
              axisEnd: _vm.dateRange.endDate,
              currentUser: _vm.currentUser,
              companyId: _vm.company.id,
              shouldClearFilters: _vm.shouldClearFilters,
              showAdditionalFilters: _vm.showAdditionalFilters,
              selectedContractorsIds: _vm.selectedContractorsIds,
            },
            on: {
              appliedFiltersChanged: _vm.handleAppliedFiltersChanged,
              rangechanged: _vm.rangeChanged,
              filtersReset: _vm.handleContractorFiltersReset,
              close: _vm.toggleAdditionalFilters,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }